import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainSetSocketNum2TwoWaySocket(data) {
  return maintainRequest({
    url: `/device/maintenanceMan/socketManage/setSocketNum2TwoWaySocket`,
    method: "post",
    data,
  });
}
